<template>
  <div class="comment">
    <span class="comment__created">{{ displayDate(message.created_at) }}</span>
    <span class="comment__author"> {{ message.author }}</span>
    <p class="comment__content">
      {{ message.message }}
    </p>
  </div>
</template>

<script>

export default {
  name: 'Message',
  props: {
    message: {
      required: true,
    },
  },
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    displayDate (date) {
      return moment(date * 1000).format('lll')
    },
  },

}

</script>

<style scoped lang="scss">
.comment {
  height: inherit;
  padding: 0.7em;
  border: 1px solid #dee5e5;
  border-radius: 5px;
  margin-top: 15px;
  position: relative;

  &:before {
    content: '';
    background-color: #dee5e5;
    margin-left: 30px;
    width: 1px;
    height: 15px;
    display: block;
    position: absolute;
    top: -16px;
  }

  &__created, &__author &__category {
    color: #57688f;
    text-transform: uppercase;
    font-weight: 600;
    font-size: 0.8em;
    white-space: nowrap;
  }

  &__author {
    flex-shrink: 1;
    min-width: 0;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &__category {
    float:right;
    font-size:0.8em !important;
    font-weight: 600 !important;
  }

  &__lecturer {
    font-size:0.8em !important;
    font-weight: 600 !important;
  }

  &__created {
    &:after {
      content: '-';
      padding: 0 0.3em;
    }
  }

  &__content {
    font-size: 0.9em;
    margin: 0;
  }
}
</style>
